import React, { useEffect, useState } from 'react';
import { Header, Icon, Loader, Message, Segment, Select } from 'semantic-ui-react';
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { getTrends } from '../../services/Metrics';

const METRIC_OPTIONS = [
  { key: 'SESSION_START', value: 'SESSION_START', text: 'Connexions (SESSION_START)' },
  { key: 'TORRENT_ADD_SEARCH', value: 'TORRENT_ADD_SEARCH', text: 'Torrents via recherche' },
  { key: 'TORRENT_ADD_MAGNET', value: 'TORRENT_ADD_MAGNET', text: 'Torrents via magnet' },
  { key: 'TORRENT_ADD_UPLOAD', value: 'TORRENT_ADD_UPLOAD', text: 'Torrents via upload' },
  { key: 'DOWNLOAD_BROWSER', value: 'DOWNLOAD_BROWSER', text: 'Téléchargements navigateur' },
  { key: 'DOWNLOAD_DEVICE', value: 'DOWNLOAD_DEVICE', text: 'Envois appareil' },
  { key: 'SEARCH_TOPBAR', value: 'SEARCH_TOPBAR', text: 'Recherches topbar' },
  { key: 'SEARCH_NO_RESULT', value: 'SEARCH_NO_RESULT', text: 'Recherches sans résultat' },
  { key: 'WATCHLIST_ADD', value: 'WATCHLIST_ADD', text: 'Ajouts watchlist' },
  { key: 'SUBSCRIPTION_ADD', value: 'SUBSCRIPTION_ADD', text: 'Abonnements séries' },
  { key: 'QBIT_RECONNECT', value: 'QBIT_RECONNECT', text: 'Reconnexions qBittorrent' },
];

const DAYS_OPTIONS = [
  { key: '7', value: 7, text: '7 jours' },
  { key: '30', value: 30, text: '30 jours' },
  { key: '60', value: 60, text: '60 jours' },
  { key: '90', value: 90, text: '90 jours' },
];

function MetricsTrendsSection() {
  const [metric, setMetric] = useState('SESSION_START');
  const [days, setDays] = useState(30);
  const [state, setState] = useState({ data: [], loading: true, error: false });

  useEffect(() => {
    setState((s) => ({ ...s, loading: true, error: false }));
    getTrends(metric, days)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          const raw = res.data.result ?? {};
          const chartData = Object.entries(raw)
            .sort((a, b) => a[0].localeCompare(b[0]))
            .map(([date, v]) => ({ date, count: v.count }));
          setState({ data: chartData, loading: false, error: false });
        } else {
          setState({ data: [], loading: false, error: true });
        }
      })
      .catch(() => setState({ data: [], loading: false, error: true }));
  }, [metric, days]);

  return (
    <Segment className="transparent-table">
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1em',
          flexWrap: 'wrap',
          gap: '0.5em',
        }}
      >
        <Header as="h3" color="teal" style={{ margin: 0 }}>
          <Icon name="line graph" />
          <Header.Content>Tendances</Header.Content>
        </Header>
        <div style={{ display: 'flex', gap: '0.5em' }}>
          <Select
            options={METRIC_OPTIONS}
            value={metric}
            onChange={(_, { value }) => setMetric(value)}
            compact
          />
          <Select
            options={DAYS_OPTIONS}
            value={days}
            onChange={(_, { value }) => setDays(value)}
            compact
          />
        </div>
      </div>
      {state.loading && <Loader active inline="centered" />}
      {state.error && <Message error content="Impossible de charger les tendances." />}
      {!state.loading && state.data.length === 0 && !state.error && (
        <Message info content="Aucune donnée pour cette métrique sur cette période." />
      )}
      {!state.loading && state.data.length > 0 && (
        <ResponsiveContainer width="100%" height={220}>
          <LineChart data={state.data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="date" tick={{ fontSize: 11 }} />
            <YAxis allowDecimals={false} />
            <Tooltip />
            <Line type="monotone" dataKey="count" stroke="#00b5ad" dot={false} strokeWidth={2} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </Segment>
  );
}

export default MetricsTrendsSection;
